import React, { useEffect, useState } from 'react'
import IconButton from '@mui/material/IconButton';
import CancelIcon from '@mui/icons-material/Cancel';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { Button } from '@mui/material';
import { useFormik } from 'formik';
import * as yup from 'yup';
import TextField from '@mui/material/TextField';
import { useStateValue, actionTypes } from '../../store';
import { notifyMe } from '../../networkCalls';

const validationSchema = yup.object({
    email: yup
        .string('Enter your email')
        .email('Enter a valid email')
        .required('Enter your email'),


});
const NotifyEmailSetup = ({ selectDealer, model, itemId, whsid }) => {
    const [{ token, huid }, dispatch] = useStateValue();
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    };
    const [openEnq, setopenEnq] = React.useState(false);
    const handleOpenEnq = () => setopenEnq(true);
    const handleCloseEnq = () => setopenEnq(false);

    const formik = useFormik({
        initialValues: {
            pName:model,
            email: '',
           
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            var data = new FormData();
            data.append('productId', itemId);
            data.append('email', values.email);
            data.append('dealerId', selectDealer);
            data.append('whsId', whsid);
            // for (var pair of data.entries()) {
            //     console.log(pair[0] + ', ' + pair[1]);
            // }
            notifyMe(data).then((res) => {
                //console.log('dsfs', res.data.status)
                switch (res.data.status) {
                    case 1:
                        //setResultData(res.data.ProductList);
                        dispatch({ type: actionTypes.SET_MSGALERTTYPE, value: 'success' });
                        dispatch({ type: actionTypes.SET_MSGALERTDATA, value: res.data.msz });
                        dispatch({ type: actionTypes.SET_MSGALERT, value: true });
                        setopenEnq(false);
                        return true;
                    case 0:
                        //setResultData(res.data.ProductList);
                        dispatch({ type: actionTypes.SET_MSGALERTTYPE, value: 'error' });
                        dispatch({ type: actionTypes.SET_MSGALERTDATA, value: res.data.msz });
                        dispatch({ type: actionTypes.SET_MSGALERT, value: true });
                        break;
                    default:
                        return;
                }
            })


        },
    });
  return (
    <>
     <Button variant="contained" onClick={handleOpenEnq}  type="submit" color="warning" className='w-100' >NOTIFY ME</Button>
     <Modal
                open={openEnq}
                // onClose={handleCloseProfile}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={{ ...style, width: { xs: 340, sm: 760 }, }}>
                    <IconButton
                        onClick={handleCloseEnq}
                        size="medium"
                        edge="start"
                        color="inherit"
                        aria-label="open drawer"
                        sx={{ float: 'right', position: 'absolute', right: '20px', top: '20px', zIndex: '3' }}
                    >
                        <CancelIcon />
                    </IconButton>
                    <div style={{ maxHeight: '550px', overflow: 'auto' }}>
                        <div className='row'>
                            <div className='col-12 mb-3'>
                                <h4 className='d-inline-block m-0 fw-bold text-uppercase'>
                                    <span className='txtred'>NOTIFY</span> <span className='txtdgray'>ME</span>
                                </h4>
                            </div>
                        </div>
                        <form onSubmit={formik.handleSubmit} autoComplete="off">
                            <div className='row'>
                                <div className='col-12 col-md-6'>
                                    <TextField
                                        disabled
                                        className='mb-3 w-100'
                                        variant="standard"
                                        id="pName"
                                        name="pName"
                                        label="Product Name"
                                        type="text"
                                        value={formik.values.pName}
                                    />
                                </div>
                               
                                <div className='col-12 col-md-6'>
                                    <TextField
                                        required
                                        className='mb-3 w-100'
                                        variant="standard"
                                        id="email"
                                        name="email"
                                        label="Email ID"
                                        type="text"
                                        value={formik.values.email}
                                        onChange={formik.handleChange}
                                        error={formik.touched.email && Boolean(formik.errors.email)}
                                        helperText={formik.touched.email && formik.errors.email}
                                    />
                                </div>

                               
                                <div className="col-md-12 col-12 mb-3">
                                   
                                </div>
                            </div>
                            <Button color="error" variant="contained" className='w-100' type="submit">
                                SEND REQUEST
                            </Button>
                        </form>
                    </div>
                </Box>
            </Modal>
    </>
  )
}

export default NotifyEmailSetup